__turbopack_context__.v({
  "iconWrapper": "PresetOptions-module-scss-module__-omSfW__iconWrapper",
  "label": "PresetOptions-module-scss-module__-omSfW__label",
});
